export const atendimentoImpressaoMessage = (isRetificacao: boolean = false) => {
  if (isRetificacao) {
    return 'Imprimir atendimento retificado ao finalizar'
  }

  return 'Imprimir atendimento ao finalizar'
}
